import { useDefinedParams } from '../hooks/useDefinedParams';
import React from 'react';
import { EPageViewType, Group } from '../types';
import { GroupView } from '../elements/group/GroupView';
import { EHttpMethod, usePortalQuery } from '../hooks/usePortalQuery';
import axios from 'axios';
import { EnvironmentVariables } from '../EnvironmentVariables';
import { useNavigate } from 'react-router-dom';
import { PageHeading } from '@portal_components/components/PageHeading';
import { useQueryClient } from '@tanstack/react-query';
import { useUserInfo } from '../hooks/useUserInfo';
import { EUserRole } from '@portal_components/types';

export const EditGroupPage = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { userInfo } = useUserInfo();
  const [groupId] = useDefinedParams(['groupId']);
  const [formSubmitted, setFormSubmitted] = React.useState<boolean>(false);

  const { data: group, isLoading: isGroupLoading } = usePortalQuery<Group>(
    EHttpMethod.GET,
    `group/${groupId}`,
    'get-group',
    true
  );

  const handleSubmit = async (values: Group): Promise<{ success: boolean; message: string }> => {
    setFormSubmitted(true);
    const response = await axios
      .post(`${EnvironmentVariables.ApiUrl}/group`, values, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      })
      .catch(error => error.response);
    if (!response) {
      setFormSubmitted(false);
      return { success: false, message: 'An error occurred while editing group.' };
    }
    if (response.status !== 200) {
      setFormSubmitted(false);
      return { success: false, message: response.data };
    }
    queryClient.resetQueries({ queryKey: ['search-groups'] });
    setTimeout(() => {
      navigate(`/`);
    }, 5000);
    return {
      success: true,
      message: 'Successfully edited group. You will be automatically redirected to the main page'
    };
  };

  if (!userInfo || userInfo.role === EUserRole.READONLY_USER)
    return <p className="text-center">You do not have permission to edit customer groups.</p>;

  return (
    <div>
      <PageHeading title="Edit Group" />
      {isGroupLoading && <div className="flex flex-row justify-center">Loading...</div>}
      {group && (
        <GroupView
          viewType={EPageViewType.EDIT}
          group={group}
          onSubmit={handleSubmit}
          formSubmitted={formSubmitted}
        />
      )}
    </div>
  );
};
